import {selectDomain} from '.';
import {createSelector} from '@reduxjs/toolkit';

export const selectAppLocale = createSelector(
  [selectDomain],
  globalState => globalState.locale
);
